import {
  FetchLoadQueryString,
  fromAPI,
} from 'doc-mate-store/lib/models/LoadQuery';

type PresetTables = {
  all: {
    results: number;
    filters: FetchLoadQueryString;
    column_ordering?: string[];
    additional_column_ordering?: string[];
    is_visible?: boolean;
  };
  active: {
    results: number;
    filters: FetchLoadQueryString;
    column_ordering?: string[];
    additional_column_ordering?: string[];
    is_visible?: boolean;
  };
  completed: {
    results: number;
    filters: FetchLoadQueryString;
    column_ordering?: string[];
    additional_column_ordering?: string[];
    is_visible?: boolean;
  };
  rejected: {
    results: number;
    filters: FetchLoadQueryString;
    column_ordering?: string[];
    additional_column_ordering?: string[];
    is_visible?: boolean;
  };
  additional_billing_all: {
    results: number;
    filters: FetchLoadQueryString;
    column_ordering?: string[];
    additional_column_ordering?: string[];
    is_visible?: boolean;
  };
  [k: string]: {
    results: number;
    filters: FetchLoadQueryString;
    column_ordering?: string[];
    additional_column_ordering?: string[];
    is_visible?: boolean;
  };
};

export function presetFiltersFromAPI(
  presetTables: PresetTables,
  preset: string,
) {
  if (presetTables[preset]) {
    return fromAPI(presetTables[preset].filters);
  }
  return {};
}

export default PresetTables;
